/* eslint-disable no-case-declarations, no-param-reassign */
import * as types from '../action.types';

export const initialState = {
  lastInsertedId: 0,
  joins: {},
};

const JoinReducer = (state = initialState, action) => {
  let newId = state.lastInsertedId;

  switch (action.type) {
    case types.FETCH_SESSION_SUCCESS:
      const joins = action.payload.joins.reduce((result, join) => {
        newId += 1;
        result[newId] = join;
        return result;
      }, {});

      return {
        lastInsertedId: newId,
        joins,
      };

    case types.CREATE_JOIN_ITEM:
      newId += 1;
      return {
        lastInsertedId: newId,
        joins: {
          ...state.joins,
          [newId]: action.payload.join,
        },
      };

    case types.RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default JoinReducer;
